import { deepMerge } from '@empathybroker/deep-merge';
import { Module } from 'vuex';
import { EmpathyXConfig, RecommendationsState } from '../../models';
import { DeepPartial } from '../../utils';
import { RootStoreState } from '../store.interfaces';
import { RECOMMENDATIONS_ACTIONS } from './recommendations.actions';
import { RECOMMENDATIONS_GETTERS } from './recommendations.getters';
import { RECOMMENDATIONS_MUTATIONS } from './recommendations.mutations';
import { getInitialRecommendationsState } from './recommendations.state';

export function getRecommendationsModule(initialConfig: EmpathyXConfig,
  overrideDefaultModule?: DeepPartial<Module<RecommendationsState, RootStoreState>>): Module<RecommendationsState, RootStoreState> {
  return deepMerge({
    namespaced: true,
    actions: RECOMMENDATIONS_ACTIONS,
    getters: RECOMMENDATIONS_GETTERS,
    mutations: RECOMMENDATIONS_MUTATIONS,
    state: getInitialRecommendationsState(initialConfig)
  }, overrideDefaultModule);
}
